import { Link } from "react-router-dom";
import type { FanTopic, NewsItem } from "@/types";
import { formatDate } from "@/utils/content";

export default function HomeSidebar({
  updates,
  topics,
}: {
  updates: NewsItem[];
  topics: FanTopic[];
}) {
  return (
    <div className="flex flex-col gap-6">
      <div className="rounded-lg border border-background-200 bg-background-100/70 p-5">
        <div className="flex items-center justify-between">
          <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
            <i className="ri-pulse-line text-primary-500" />
            动态更新
          </h3>
          <Link to="/news" className="text-xs font-medium text-primary-600 hover:text-primary-700">
            全部
          </Link>
        </div>
        <ul className="mt-4 space-y-4">
          {updates.map((item) => (
            <li key={item.id}>
              <Link to={`/detail/${item.id}`} className="group flex items-start gap-3">
                <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-accent-500 ring-4 ring-accent-100" />
                <span className="min-w-0">
                  <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </span>
                  <span className="mt-1 block text-xs text-foreground-500">
                    {formatDate(item.date)}
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <div className="flex items-center justify-between">
          <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
            <i className="ri-fire-line text-primary-500" />
            精选专题
          </h3>
          <Link to="/fans" className="text-xs font-medium text-primary-600 hover:text-primary-700">
            更多
          </Link>
        </div>
        <ul className="mt-4 space-y-3">
          {topics.map((topic) => (
            <li key={topic.id}>
              <Link
                to="/fans"
                className="group flex items-center justify-between gap-3 rounded-md border border-transparent px-2 py-2 transition-colors hover:border-background-200 hover:bg-background-100"
              >
                <span className="min-w-0">
                  <span className="line-clamp-1 text-sm text-foreground-800 transition-colors group-hover:text-primary-600">
                    {topic.title}
                  </span>
                  <span className="mt-0.5 block text-xs text-foreground-500">
                    {topic.replies} 条讨论
                  </span>
                </span>
                <i className="ri-arrow-right-s-line shrink-0 text-foreground-400" />
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="overflow-hidden rounded-lg bg-secondary-800 p-5 text-background-100">
        <h3 className="font-heading text-base font-bold text-background-50">关于风间由美</h3>
        <p className="mt-3 text-sm leading-relaxed text-background-300">
          演员、歌手。以克制的表演与真诚的创作，持续在影视与音乐领域探索。
        </p>
        <Link
          to="/about"
          className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-xs font-semibold text-secondary-950 transition-colors hover:bg-accent-400"
        >
          了解她
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </div>
  );
}